/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Few_Front_Lemming_BelongInputs */

const fr_few_front_lemming_belong = /** @type {(inputs: Few_Front_Lemming_BelongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion des roles`)
};

/**

* @param {Few_Front_Lemming_BelongInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const few_front_lemming_belong = /** @type {((inputs?: Few_Front_Lemming_BelongInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Few_Front_Lemming_BelongInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_few_front_lemming_belong(inputs)
});